<template>
  <b-row
    align-v="stretch"
    class="week-nothing"
  >
    <b-col
      v-if="question.type == 'exitmodal'"
      align-self="center"
    >
      <b-row align-h="center">
        <b-col
          cols="12"
          md="6"
          class="tw-text-center"
        >
          <h1 class="text-center question-title-v2 mb-4">
            {{ question.title }}
          </h1>
          <!-- <p class="sub-text group-mb text-center text-muted mb-4">
            {{ question.description }}
          </p> -->

          <b-row
            align-v="center"
            align-h="center"
            class="mt-5 mb-4 mx-auto"
          >
            <b-col cols="auto">
              <b-avatar
                variant="primary"
                :src="question.doctor.profileUrl"
                size="7rem"
              />
            </b-col>
            <b-col cols="auto">
              <h2 class="mb-0 bold d-letter-spacing">
                Dr. {{ question.doctor.firstname }}
                {{ question.doctor.lastname }}
              </h2>
              <!-- <p class="mb-0 loader-sub-text">License #: G80363</p> -->
            </b-col>
          </b-row>

          <b-row
            align-v="center"
            align-h="center"
            class="mt-3 mb-3 mx-auto"
          >
            <b-col
              cols="auto"
              class="tw-bg-slate-50 p-4"
            >
              <span
                class="question-title-v2"
                style="font-size: 1.2rem"
              >How would you rate your Winona experience so far?</span>
              <div class="mt-3">
                <b-button
                  v-for="i in 10"
                  :key="i"
                  variant="outline-info slight-rounded mr-2"
                  :pressed="selectedRating === i"
                  @click="selectedRating = i"
                >
                  {{ i }}
                </b-button>
              </div>
            </b-col>
          </b-row>

          <button
            class="tw-my-5 tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
            :disabled="disabled"
            @click="submitAnswer"
          >
            Continue
          </button>
        </b-col>
      </b-row>
    </b-col>
    <b-col
      v-else
      align-self="center"
      class="d-flex flex-column"
    >
      <h2 class="text-center question-title-v2 mb-2">
        {{ question.title }},
      </h2>
      <p
        v-if="question.description"
        class="sub-text group-mb text-center mb-4"
      >
        {{ question.description }}
      </p>
      <div class="align-self-center">
        <button
          class="tw-my-5 tw-w-[300px] tw-rounded-lg tw-p-2 tw-uppercase tw-font-bold tw-tracking-[0.15rem] tw-bg-[#a783ff] tw-text-white"
          :disabled="disabled"
          @click="submitAnswer"
        >
          Continue
        </button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { AnalyticsService } from '@/services/analytics.service';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      selectedRating: null,
      disabled: false,
    };
  },
  methods: {
    submitAnswer() {
      if (this.selectedRating) {
        AnalyticsService.submitNPSSurveyResponse(this.selectedRating);
      }

      this.disabled = true;
      this.$emit('submitAnswer', this.question.id, '');
      this.disabled = false;
    },
  },
};
</script>

<style></style>
